 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "assets/js/" + ({"chapter2~lobby":"chapter2~lobby","chapter2":"chapter2","lobby":"lobby"}[chunkId]||chunkId) + "." + {"chapter2~lobby":"e2dd67de","chapter2":"f2ee31cf","lobby":"83615b0f","chunk-16bc9b30":"6b6e98be","chunk-1900632a":"432eee5e","chunk-23a1525a":"fb6332a5","chunk-2d0a3586":"81daf040","chunk-2d0ae52b":"9d767597","chunk-2d0ae9c1":"4bb95608","chunk-2d0b1df3":"3e93688e","chunk-2d0b3dec":"eb8bd400","chunk-2d0b6a7d":"8a9fc4d6","chunk-2d0b8a57":"8df3fea2","chunk-2d0ba398":"123da999","chunk-2d0ba717":"08173535","chunk-2d0bd96a":"2c8f7766","chunk-2d0bd9b9":"f2fce1a7","chunk-2d0c0da7":"e8ea3737","chunk-2d0c1798":"e11e1895","chunk-2d0c5b53":"58fa2ca4","chunk-2d0c7ad8":"12712c0e","chunk-2d0c8c05":"33848097","chunk-2d0c96fe":"6e40573f","chunk-2d0cc7b5":"22ca1337","chunk-2d0ccbe7":"0f8ff882","chunk-2d0d36b7":"988c9bc0","chunk-2d0d7fd8":"2cea34fb","chunk-2d0de141":"aa847a32","chunk-2d0e19f3":"6a4ebe96","chunk-2d0e26c6":"11e2c659","chunk-2d0e28e6":"f7bc4f9a","chunk-2d0e2c87":"19ac6142","chunk-2d0e5766":"eebda5d8","chunk-2d0e5f33":"59c96de6","chunk-2d0e9020":"2554cbda","chunk-2d2073e6":"7456076a","chunk-2d2080b7":"f02543b8","chunk-2d2085ee":"1c95b370","chunk-2d2088c5":"7d5d64a4","chunk-2d20916b":"c11b6f2b","chunk-2d2093b8":"ec21e1b5","chunk-2d20e834":"d1c074f0","chunk-2d20ef8b":"f507159f","chunk-2d20f389":"ef74700c","chunk-2d20fee9":"771722a7","chunk-2d210468":"67695de3","chunk-2d210868":"404125b5","chunk-2d210fab":"50747800","chunk-2d215cbd":"4c3f23f8","chunk-2d2163d5":"31283a2b","chunk-2d2167a4":"a5071a3f","chunk-2d21abd0":"1794565d","chunk-2d21d4a3":"c3e01bcc","chunk-2d21e023":"46ac7656","chunk-2d2248a3":"a75f1ad1","chunk-2d224979":"e43edb37","chunk-2d225434":"4448d8ed","chunk-2d225b78":"8f785d10","chunk-2d2297b8":"9a523ded","chunk-2d22bef6":"a518a333","chunk-2d230133":"b73baccb","chunk-2d231006":"638b0a20","chunk-2d237f12":"f208d49d","chunk-2d98bc12":"66c0a3ba","chunk-5268d92d":"7d9a579d","chunk-55c6b038":"a53025d8","chunk-6556e814":"968dde85","chunk-6ecbda82":"6cd592bc","chunk-84554808":"4f9620a7","chunk-8fd2c6da":"b5f5763c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chapter2~lobby":1,"chapter2":1,"lobby":1,"chunk-16bc9b30":1,"chunk-1900632a":1,"chunk-23a1525a":1,"chunk-2d98bc12":1,"chunk-55c6b038":1,"chunk-6556e814":1,"chunk-6ecbda82":1,"chunk-84554808":1,"chunk-8fd2c6da":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "assets/css/" + ({"chapter2~lobby":"chapter2~lobby","chapter2":"chapter2","lobby":"lobby"}[chunkId]||chunkId) + "." + {"chapter2~lobby":"26a0d393","chapter2":"d66d49c1","lobby":"a0828155","chunk-16bc9b30":"b3dafcb3","chunk-1900632a":"9638ff64","chunk-23a1525a":"0e433876","chunk-2d0a3586":"31d6cfe0","chunk-2d0ae52b":"31d6cfe0","chunk-2d0ae9c1":"31d6cfe0","chunk-2d0b1df3":"31d6cfe0","chunk-2d0b3dec":"31d6cfe0","chunk-2d0b6a7d":"31d6cfe0","chunk-2d0b8a57":"31d6cfe0","chunk-2d0ba398":"31d6cfe0","chunk-2d0ba717":"31d6cfe0","chunk-2d0bd96a":"31d6cfe0","chunk-2d0bd9b9":"31d6cfe0","chunk-2d0c0da7":"31d6cfe0","chunk-2d0c1798":"31d6cfe0","chunk-2d0c5b53":"31d6cfe0","chunk-2d0c7ad8":"31d6cfe0","chunk-2d0c8c05":"31d6cfe0","chunk-2d0c96fe":"31d6cfe0","chunk-2d0cc7b5":"31d6cfe0","chunk-2d0ccbe7":"31d6cfe0","chunk-2d0d36b7":"31d6cfe0","chunk-2d0d7fd8":"31d6cfe0","chunk-2d0de141":"31d6cfe0","chunk-2d0e19f3":"31d6cfe0","chunk-2d0e26c6":"31d6cfe0","chunk-2d0e28e6":"31d6cfe0","chunk-2d0e2c87":"31d6cfe0","chunk-2d0e5766":"31d6cfe0","chunk-2d0e5f33":"31d6cfe0","chunk-2d0e9020":"31d6cfe0","chunk-2d2073e6":"31d6cfe0","chunk-2d2080b7":"31d6cfe0","chunk-2d2085ee":"31d6cfe0","chunk-2d2088c5":"31d6cfe0","chunk-2d20916b":"31d6cfe0","chunk-2d2093b8":"31d6cfe0","chunk-2d20e834":"31d6cfe0","chunk-2d20ef8b":"31d6cfe0","chunk-2d20f389":"31d6cfe0","chunk-2d20fee9":"31d6cfe0","chunk-2d210468":"31d6cfe0","chunk-2d210868":"31d6cfe0","chunk-2d210fab":"31d6cfe0","chunk-2d215cbd":"31d6cfe0","chunk-2d2163d5":"31d6cfe0","chunk-2d2167a4":"31d6cfe0","chunk-2d21abd0":"31d6cfe0","chunk-2d21d4a3":"31d6cfe0","chunk-2d21e023":"31d6cfe0","chunk-2d2248a3":"31d6cfe0","chunk-2d224979":"31d6cfe0","chunk-2d225434":"31d6cfe0","chunk-2d225b78":"31d6cfe0","chunk-2d2297b8":"31d6cfe0","chunk-2d22bef6":"31d6cfe0","chunk-2d230133":"31d6cfe0","chunk-2d231006":"31d6cfe0","chunk-2d237f12":"31d6cfe0","chunk-2d98bc12":"a1823fb6","chunk-5268d92d":"31d6cfe0","chunk-55c6b038":"7e303328","chunk-6556e814":"13f54618","chunk-6ecbda82":"aed9c2c1","chunk-84554808":"df250851","chunk-8fd2c6da":"75479e3e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
